export const CalculateGeometric = (start: number, end: number, step: number): number[] => {
  const 
    median = start === end ? Math.max(start, end) : Math.floor(((end - start) * 50 / 100 + start)),
    ratio = Math.pow(median, 1 / (Math.floor(step / 2))) <= 2 ? Math.pow(median, 1 / (Math.floor(step / 2))) : 2,
    ratioList = [];
  for(let count = 1; count < Math.floor(step / 2); count++) {
    ratioList.push(Math.round(Math.pow(ratio, count)));
  }
  const startList = ratioList.map((ratio) => {
    if(start < end) {
      return median < start + ratio ? median : start + ratio;
    } else {
      return median < start - ratio ? start - ratio : median;
    }
  });
  const endList = ratioList.slice(0).reverse().map((ratio) => {
    if(start < end) {
      return median < end - ratio ? end - ratio : median;
    } else {
      return median < end + ratio ? median : end + ratio;
    }
  });
  return step % 2 === 0 ? [start, ...startList, ...endList, end] : [start, ...startList, median, ...endList, end]; 
}